import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../css/Calendar.css";

const GoogleCalendarPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="calendar-container">
      <p className="calendar-description">
        You can either give us a ring or book an appointment to have a consultation with our pharmacist by clicking the button below.
      </p>
      {/* Open Button */}
      <button
        className="calendar-button"
        onClick={() => setIsOpen(true)}
      >
        Book an Appointment
      </button>

      {/* Modal Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-overlay"
            onClick={() => setIsOpen(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", duration: 0.5 }}
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="modal-close-button"
                onClick={() => setIsOpen(false)}
                aria-label="Close modal"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              {/* Modal Content */}
              <h2 className="modal-title">Schedule an Appointment</h2>
              <div className="calendar-iframe-container">
                <iframe
                  src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2_mJOLhObiceux6w8sJPClwaboBR1LJC_YNONkmvDFln1cVwvKiVzdbuiMboJ-Q4XsS8MSm2jC?gv=true"
                  style={{ border: 0 }}
                  width="100%"
                  height="600"
                  frameBorder="0"
                />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default GoogleCalendarPopup;